module.exports = __webpack_public_path__ + "img/new17.698f51cb.png";